import { DEFAULT_PROFILE_IMAGE } from "@/assets/config"

/**
 * Eine Helferfunktion, die als @error-Handler für <img>-Tags verwendet wird.
 * Wenn ein Bild nicht geladen werden kann, wird die `src` auf das Standard-Avatarbild gesetzt.
 * @param {Event} e - Das Fehlerereignis des <img>-Tags.
 */
export function onImageError(e) {
  const img = e.target
  if (img && img.src !== DEFAULT_PROFILE_IMAGE) img.src = DEFAULT_PROFILE_IMAGE
}